
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0300"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0300"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $4AGbv = parcelRequire("4AGbv");

var $iNA1s = parcelRequire("iNA1s");
(0, $4AGbv.default).registerPlugin((0, $iNA1s.default));
// --- Sélection de toutes les sections ---
const $9968b60760db0d8d$var$sections = document.querySelectorAll(".start, .branches-wrapper, .moi, .homepage-projet, .autres, .contact");
$9968b60760db0d8d$var$sections.forEach((section)=>{
    // --- Section branches spéciale ---
    if (section.classList.contains("branches-wrapper")) {
        const branches = (0, $4AGbv.default).utils.toArray(".branches");
        const titles = (0, $4AGbv.default).utils.toArray(".branches-titre");
        // Superposition des fonds et invisibilité des titres
        branches.forEach((branch, i)=>{
            (0, $4AGbv.default).set(branch, {
                autoAlpha: i === 0 ? 1 : 0
            });
        });
        titles.forEach((title)=>(0, $4AGbv.default).set(title, {
                opacity: 0,
                y: 40
            }));
        // Timeline globale pour le wrapper branches
        const tlBranches = (0, $4AGbv.default).timeline({
            scrollTrigger: {
                trigger: section,
                start: "top top",
                end: "+=" + branches.length * 150 + "%",
                pin: true,
                pinSpacing: true,
                scrub: 1.2
            }
        });
        // Animation des titres et crossfade des fonds
        branches.forEach((branch, i)=>{
            // Faire apparaître le titre
            if (titles[i]) tlBranches.to(titles[i], {
                opacity: 1,
                y: 0,
                duration: 1,
                ease: "power2.out"
            }, "+=0.5");
            // Crossfade vers le fond suivant
            if (branches[i + 1]) {
                tlBranches.to(branch, {
                    autoAlpha: 0,
                    duration: 0.8,
                    ease: "power2.inOut"
                }, "+=1");
                tlBranches.to(branches[i + 1], {
                    autoAlpha: 1,
                    duration: 0.8
                }, "<");
            }
        });
    } else {
        const content = section.querySelector(".start, .moi-content, .homepage-projet-content, .autres-title, .contact-content");
        const tl = (0, $4AGbv.default).timeline({
            scrollTrigger: {
                trigger: section,
                start: "top top",
                end: "+=200%",
                pin: true,
                pinSpacing: true,
                scrub: 1.6
            }
        });
        // Petite pause avant animation
        tl.to({}, {
            duration: 0.35
        });
        // Animation d'arrivée
        if (content) tl.fromTo(content, {
            opacity: 0,
            y: 140,
            scale: 0.98
        }, {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.9,
            ease: "power4.out"
        });
        // Pause "respiration"
        tl.to({}, {
            duration: 1.2
        });
        // Animation de sortie
        if (content) tl.to(content, {
            opacity: 0,
            y: -80,
            scale: 1.02,
            duration: 0.8,
            ease: "power2.inOut"
        });
    }
});
// --- Effet H1 lettres une par une ---
window.addEventListener("load", ()=>{
    const h1 = document.querySelector(".start h1");
    // Découpe le texte en spans (une lettre par span)
    const text = h1.textContent;
    h1.textContent = "";
    text.split("").forEach((char)=>{
        const span = document.createElement("span");
        span.textContent = char === " " ? "\xa0" : char; // garde les espaces
        span.style.display = "inline-block";
        h1.appendChild(span);
    });
    const letters = h1.querySelectorAll("span");
    // État de départ : incliné et invisible
    (0, $4AGbv.default).set(letters, {
        skewX: -15,
        opacity: 0,
        transformOrigin: "left center"
    });
    // Animation lettre par lettre
    (0, $4AGbv.default).to(letters, {
        skewX: 0,
        opacity: 1,
        duration: 0.8,
        ease: "power3.out",
        stagger: 0.05,
        delay: 0.2
    });
});
const $9968b60760db0d8d$var$signature = document.querySelector(".signature");
(0, $4AGbv.default).fromTo($9968b60760db0d8d$var$signature, {
    opacity: 0,
    y: 12
}, {
    opacity: 1,
    y: 0,
    ease: "power2.out",
    scrollTrigger: {
        trigger: ".contact",
        start: "bottom bottom",
        toggleActions: "play none none reverse"
    }
});


//# sourceMappingURL=index.c7a067a9.js.map
